import { render } from "./PrepareTab.vue?vue&type=template&id=785975bc&scoped=true"
import script from "./PrepareTab.vue?vue&type=script&lang=js"
export * from "./PrepareTab.vue?vue&type=script&lang=js"

import "./PrepareTab.vue?vue&type=style&index=0&id=785975bc&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src973090976/src/remoterespects-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785975bc"]])

export default __exports__